// Production GA4 only. Measurement id and debug storage key come from env.
// Dead Universal Analytics and the old staging measurement id are removed in vue.config.js.
const MEASUREMENT_ID = process.env.VUE_APP_MEASUREMENT_ID
const DEBUG_STORAGE_KEY = process.env.VUE_APP_DEBUG_STORAGE_KEY

const ROUTE_EVENTS = {
    'auth.login': 'landing_view',
    'auth.signup.register': 'registration_started',
    'auth.signup.register.demo': 'registration_started',
    'index.home': 'portal_arrived',
}

function isProduction() {
    return process.env.VUE_APP_ENV === 'production'
}

function isDebugSession() {
    try {
        const params = new URLSearchParams(window.location.search)
        const debug = params.get('ga_debug') === '1'
        if (!DEBUG_STORAGE_KEY) {
            return debug
        }
        if (debug) {
            sessionStorage.setItem(DEBUG_STORAGE_KEY, '1')
        }
        return sessionStorage.getItem(DEBUG_STORAGE_KEY) === '1'
    } catch (error) {
        return false
    }
}

function pagePath(route) {
    return (route && route.path) || window.location.pathname || '/'
}

export default {
    init() {
        if (!isProduction() || !MEASUREMENT_ID || window.gtag) {
            return
        }

        window.dataLayer = window.dataLayer || []
        window.gtag = function gtag() {
            window.dataLayer.push(arguments)
        }
        window.gtag('js', new Date())
        window.gtag('config', MEASUREMENT_ID, {
            send_page_view: false,
            debug_mode: isDebugSession(),
        })

        if (document.getElementById('google-analytics')) {
            return
        }

        const script = document.createElement('script')
        script.id = 'google-analytics'
        script.async = true
        script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`
        document.head.appendChild(script)
    },

    trackPageView(route) {
        if (!isProduction() || !window.gtag || !route) {
            return
        }

        const path = pagePath(route)
        this.event('page_view', {
            page_title: route.name || document.title,
            page_location: `${window.location.origin}${path}`,
            page_path: path,
        })

        const funnelEvent = ROUTE_EVENTS[route.name]
        if (funnelEvent) {
            this.event(funnelEvent, { page_path: path })
        }
    },

    event(name, params = {}) {
        if (!isProduction() || !window.gtag || !name) {
            return
        }

        const payload = {
            page_path: window.location.pathname,
            ...params,
        }

        if (isDebugSession()) {
            payload.debug_mode = true
        }

        window.gtag('event', name, payload)
    },
}
